<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Add iSMS</h2>
            </div>
        </div>
        <a-card>
            <a-form :form="form"  @submit="handleSubmit">
                <div class="row">
                    <div class="mb-6 col-md-6">
                        <a-form-item label="Title">
                            <a-input size="large"
                                v-decorator="['title', { rules: [{ required: true, message: 'Please enter name' }] }]"
                                placeholder="Enter Title"
                            />
                        </a-form-item>
                    </div>
                    <div class="mb-6 col-md-6">
                        <a-form-item label="API Url">
                        <a-input size="large"
                            v-decorator="['api_url', { rules: [{ required: true, message: 'Please enter name' }] }]"
                            placeholder="Enter API Url"
                        />
                        </a-form-item>
                    </div>

                    <div class="mb-6 col-md-6">
                        <a-form-item label="SID">
                        <a-input size="large"
                            v-decorator="['sid', { rules: [{ required: true, message: 'Please enter name' }] }]"
                            placeholder="Enter SID"
                        />
                        </a-form-item>
                    </div>
                    <div class="mb-6 col-md-6">
                        <a-form-item label="Key">
                        <a-input size="large"
                            v-decorator="['key', { rules: [{ required: true, message: 'Please enter name' }] }]"
                            placeholder="Enter Key"
                        />
                        </a-form-item>
                    </div>
                    <div class="mb-6 col-md-6">
                        <a-form-item label="Secret">
                            <a-input size="large"
                                v-decorator="['secret', { rules: [{ required: true, message: 'Please enter name' }] }]"
                                placeholder="Enter Secret"
                            />
                        </a-form-item>
                    </div>
                </div>

                <a-form-item >
                    <a-button type="primary" class="btn btn-xs" size="large" html-type="submit">
                        Add iSMS
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>
    </div>
</template>
<script>
import { iSMS_CREATE } from "../../../../script/api";
import { postData } from "../../../../script/api-service";
import {alertPop} from "../../../../script/helper";

export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields( async(err, values) => {
        if (!err) {
            values.company_id = 1;
          let res = await postData(iSMS_CREATE, values);

          if (res) {
            this.form.resetFields();
            alertPop('success', 'iSMS added successfully!');
            this.$router.push({ path: '/iSMS-manage' });
          }
        }
      });
    },
  },
};
</script>